const NO_RESPONSE_PLACEHOLDER = '_No response_'
const COMMENT_START = '<!--'
const COMMENT_END = '-->'

/**
 * Removes HTML comments from a string.
 * Uses indexOf-based scanning instead of a regular expression to avoid
 * quadratic backtracking on inputs with many unterminated '<!--' sequences.
 */
function stripHtmlComments(text: string): string {
  let result = ''
  let index = 0

  while (index < text.length) {
    const start = text.indexOf(COMMENT_START, index)
    if (start === -1) {
      result += text.slice(index)
      break
    }

    const end = text.indexOf(COMMENT_END, start + COMMENT_START.length)
    if (end === -1) {
      result += text.slice(index)
      break
    }

    result += text.slice(index, start)
    index = end + COMMENT_END.length
  }

  return result
}

/**
 * Removes default placeholders and HTML comments (invisible boilerplate).
 * Use only for light-weight normalization for duplicate check length threshold calculation.
 */
export function normalizeForDuplicateThreshold(body: string): string {
  return stripHtmlComments(body).replaceAll(NO_RESPONSE_PLACEHOLDER, '').trim()
}
